import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformationService} from "../../services/information.service";
import {Subject, takeUntil} from "rxjs";
import {environment} from "../../../environments/environment";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.less']
})
export class CookiePolicyComponent implements OnInit, OnDestroy{

  addressLink: string;
  shopAddress : string;
  worktime : SafeHtml;
  phone : string;
  email : string;

  private destroySubject: Subject<void> = new Subject();

  constructor(
    private informationService: InformationService,
  ) {
    this.shopAddress = environment.shopAddress.address;
    this.addressLink = environment.shopAddress.link;
  }

  ngOnInit(): void {
    this.informationService.getFrontParams().pipe(
      takeUntil(this.destroySubject),
    )
      .subscribe(
        (res: any) => {
          this.shopAddress = res.results.find ((value:any) =>  value.name == 'address')?.value;
          this.phone = res.results.find ((value:any) =>  value.name == 'phone')?.value;
          this.email = res.results.find ((value:any) =>  value.name == 'email')?.value;

            let worktimeHtml  = res.results.find ((value:any) =>  value.name == 'worktime')?.value;
            this.worktime =  this.informationService.getSanitizeString(worktimeHtml);

        })
  }



  ngOnDestroy() {
    this.destroySubject.next();
  }

}




